<template>
  <el-form-item class="macros">
    <el-collapse value="1">
      <el-collapse-item title="Available macros" name="1">
        <p class="macros__group">
          <strong class="macros__title">Main</strong>
          <span
            v-for="(description, macro) of macros"
            :key="macro"
            class="macros__item"
          >
            <strong>{{ '{{' + macro + '\}\}' }}</strong> - {{ description }}.
          </span>
        </p>
        <p class="macros__group">
          <strong class="macros__title">SEC CH UA</strong>
          <span
            v-for="(description, macro) of secMacrosLow"
            :key="macro"
            class="macros__item"
          >
            <strong>{{ '{{' + macro + '\}\}' }}</strong> - {{ description }}.
          </span>
          <span class="macros__hint">
            Data required to populate the following SEC-CH-UA macros may not
            always be available.
          </span>
          <span
            v-for="(description, macro) of secMacrosHigh"
            :key="macro"
            class="macros__item"
          >
            <strong>{{ '{{' + macro + '\}\}' }}</strong> - {{ description }}.
          </span>
        </p>
        <p class="macros__group">
          <strong class="macros__title">Additional</strong>
          <span
            v-for="(description, macro) of additionalMacros"
            :key="macro"
            class="macros__item"
          >
            <strong>{{ '{{' + macro + '\}\}' }}</strong> - {{ description }}.
          </span>
        </p>

        <p>
          Feed example: https://himapaat.com/api/bid/338396?ip={{
            '{{IP\}\}'
          }}&ua={{ '{{UA\}\}' }}&ref={{ '{{REF\}\}' }}&query={{
            '{{KW\}\}'
          }}&sub1={{ '{{SUB\}\}' }}&format=xml
        </p>
      </el-collapse-item>
    </el-collapse>
  </el-form-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'FeedMacrosInfo',
  setup() {
    const macros = {
      REF: 'Full page URL where ads were shown',
      KW: 'Keywords from the website page',
      DOMAIN: 'Top domain where ads were shown',
      SUB: 'ID of the spot that displayed your ad',
      LANG: "Visitor's main language",
      IP: "Visitor's IPv4 address",
      UA: "Visitor's User-Agent"
    }

    const secMacrosLow = {
      SECCHUA: 'Sec-Ch-Ua',
      SECCHUAMOBILE: 'Sec-Ch-Ua-Mobile',
      SECCHUAPLATFORM: 'Sec-Ch-Ua-Platform'
    }
    const secMacrosHigh = {
      SECCHUABITNESS: 'Sec-Ch-Ua-Bitness',
      SECCHUAMODEL: 'Sec-Ch-Ua-Model',
      SECCHUAPLATFORMVERSION: 'Sec-Ch-Ua-Platform-Version',
      SECCHUAARCH: 'Sec-Ch-Ua-Arch',
      SECCHUAFORMFACTORS: 'Sec-Ch-Ua-Form-Factors',
      SECCHUAFULLVERSION: 'Sec-Ch-Ua-Full-Version',
      SECCHUAFULLVERSIONLIST: 'Sec-Ch-Ua-Full-Version-List',
      SECCHUAWOW64: 'Sec-Ch-Ua-Wow64'
    }

    const additionalMacros = {
      GEO: 'country code (2 digits)',
      ID: 'unique id of each ad impression',
      UUID: 'unique id of each visitor ( unique for IP+UA + Spot)',
      XFF_IP: 'x_forwarded_for of the visitor',
      RIP: 'Remote Address of the visitor',
      XRW: 'XRequestedWith of the visitor'
    }

    return { macros, secMacrosLow, secMacrosHigh, additionalMacros }
  }
})
</script>

<style lang="scss" scoped>
.macros {
  margin-top: 20px;

  &__group {
    margin-bottom: 12px;
  }

  &__title {
    color: #2163a7;
  }

  &__item {
    display: block;
  }

  &__hint {
    display: block;
    margin-top: 8px;
    color: #e6a23c;
  }
}
</style>
